import logo from '../../assets/renzfoods-logo_transparent.png';


const Home = () => {
    return (
        <header className="App-header">
            <p className='underconstruction'>UNDER CONSTRUCTION</p>
            <h1 className='mahalo'>CHEE HOO!</h1>
            <img src={logo} className="App-logo" alt="logo" />
        </header>
    )
}

export default Home;